import { render, staticRenderFns } from "./Bienvenido.vue?vue&type=template&id=6f638d4c"
import script from "./Bienvenido.vue?vue&type=script&lang=js"
export * from "./Bienvenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports